import i18n from "@/i18n";
import {LOCALES} from "@/enums/locales";

const locale = localStorage.getItem("locale");

if (locale) {
    i18n.locale = LOCALES[locale];
} else {
    i18n.locale = LOCALES["pt_pt"];
}

const profilesMapping = {
    1: i18n.t("navbar.profilesLabels.admin"),
    2: i18n.t("navbar.profilesLabels.coordinator"),
    3: i18n.t("navbar.profilesLabels.manager"),
    4: i18n.t("navbar.profilesLabels.business_manager"),
    5: i18n.t("navbar.profilesLabels.seller"),
    6: i18n.t("navbar.profilesLabels.financial"),
    7: i18n.t("navbar.profilesLabels.financial_jr"),
    8: i18n.t("navbar.profilesLabels.seller_boss"),
    9: i18n.t("navbar.profilesLabels.superAdmin")
};

const PROFILES_ENUM = {
    ADMIN: 1,
    COORDINATOR: 2,
    MANAGER: 3,
    BUSINESS_MANAGER: 4,
    SELLER: 5,
    FINANCIAL: 6,
    FINANCIAL_JR: 7,
    BUSINESS_BOSS: 8,
    SUPER_ADMIN: 9,
};

function generateProfile(proposalModule, proposalList, backofficeModule, usersList, usersGroupList, entitiesList, companiesList, sitesList, financialData, financeList, insuranceList) {
    return {
        "proposalModule": proposalModule,
        "proposalList": proposalList,
        "backofficeModule": backofficeModule,
        "usersList": usersList,
        "usersGroupList": usersGroupList,
        "entitiesList": entitiesList,
        "companiesList": companiesList,
        "sitesList": sitesList,
        "financialData": financialData,
        "financeList": financeList,
        "insuranceList": insuranceList
    };
}

const SIDEBAR_ENUM = {
    // SUPER ADMIN
    1: generateProfile(false, false, false, false, false, false, false, false, false, false, false),
    // COORDINATOR
    2: generateProfile(false, false, false, false, false, false, false, true, false, false, false),
    // MANAGER
    3: generateProfile(false, false, true, true, false, true, true, true, true, true, true),
    // BUSINESS_MANAGER
    4: generateProfile(false, false, false, false, true, true, true, true, true, true, true),
    // SELLER
    5: generateProfile(true, true, true, true, true, true, true, true, true, true, true),
    // FINANCIAL
    6: generateProfile(false, false, true, true, true, true, true, true, true, true, true),
    // FINANCIAL_JR
    7: generateProfile(false, false, true, true, true, true, true, true, true, true, true),
    // BUSINESS_BOSS
    8: generateProfile(false, false, true, true, true, true, true, true, true, true, true),
    // ADMIN
    9: generateProfile(false, false, false, false, false, false, false, false, false, false, false),
};

const sidebarVisibility = (profileID, module) => {
    return SIDEBAR_ENUM[profileID][module];
};

export {profilesMapping, PROFILES_ENUM, sidebarVisibility};
